import { createFileRoute } from "@tanstack/react-router";
import { getCalendarItem } from "api-client";
import { assert } from "utils";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachAthleteCalendarItemPage } from "src/pages/CoachAthleteCalendarItemPage";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/calendar/$calendarItemId",
)({
  component: RouteComponent,
  ssr: true,
  shouldReload: false,
  async loader({ params }) {
    return await loaderHandler(async () => {
      assert(params.calendarItemId, "params.calendarItemId is required");

      const response = await getCalendarItem({
        path: {
          calendarItemId: params.calendarItemId,
        },
      });
      const calendarItem = response.data.data;

      const athleteId = calendarItem.user.athlete?.id;

      assert(athleteId, "Calendar item should be assigned to an athlete");

      return {
        data: {
          calendarItem,
        },
      };
    });
  },
});

function RouteComponent() {
  return <CoachAthleteCalendarItemPage />;
}
